import React from 'react';

import TermsOfUse from 'components/docs/TermsOfUse';
import PageTitleBar from 'components/misc/PageTitleBar';

const TermsOfUsePage = () => (
  <div>
    <PageTitleBar
      title="클럽아티제이용약관"
      titleLangKor
      backgroundImage={require('../assets/images/banner/agreement.jpg')}
    />
    <TermsOfUse />
  </div>
);

export default TermsOfUsePage;
